import { withEventContext } from "@codat/analytics";
import useQueryParams from "hooks/useQueryParams";
import { useEffect } from "react";
import { usePageViewedEvent } from "utils";

import styles from "./Completed.module.css";

function CompletedContent() {
  usePageViewedEvent({
    ready: true,
  });

  const queryParams = useQueryParams();

  useEffect(() => {
    const isEmbeddedLink =
      queryParams.get("link.embedded")?.toLowerCase() === "true";

    if (isEmbeddedLink) {
      window.close();
    }
  }, [queryParams]);

  return (
    <div className={styles.container}>
      <span data-testid="completed-message" className={styles.message}>
        You may now close this window
      </span>
    </div>
  );
}

export const Completed = withEventContext(CompletedContent, "Completed page");
